const AUTH_RECOVERY_LOOP_KEY = 'pointcraft_auth_recovery_loop';
const AUTH_RECOVERY_WINDOW_MS = 10 * 60 * 1000;
const MAX_AUTH_RECOVERIES_PER_WINDOW = 3;

interface RecoveryLoopState {
  startedAt: number;
  count: number;
}

function readState(): RecoveryLoopState | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(AUTH_RECOVERY_LOOP_KEY);
  if (!raw) return null;
  try {
    const state = JSON.parse(raw) as Partial<RecoveryLoopState>;
    if (typeof state.startedAt !== 'number' || typeof state.count !== 'number') return null;
    return { startedAt: state.startedAt, count: state.count };
  } catch {
    return null;
  }
}

export function registerAuthRecoveryAttempt(now = Date.now()): boolean {
  if (typeof localStorage === 'undefined') return true;
  const existing = readState();
  const state =
    !existing || now - existing.startedAt >= AUTH_RECOVERY_WINDOW_MS
      ? { startedAt: now, count: 1 }
      : { ...existing, count: existing.count + 1 };
  localStorage.setItem(AUTH_RECOVERY_LOOP_KEY, JSON.stringify(state));
  return state.count <= MAX_AUTH_RECOVERIES_PER_WINDOW;
}

export function clearAuthRecoveryAttempts(): void {
  if (typeof localStorage !== 'undefined') localStorage.removeItem(AUTH_RECOVERY_LOOP_KEY);
}

export { AUTH_RECOVERY_LOOP_KEY };
